module.exports = __webpack_public_path__ + "static/media/logo-white.0f5bd61d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/logo-white.png
 ** module id = 593
 ** module chunks = 0
 **/